"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromToPaginationSchema = exports.DEFAULT_PAGE_SIZE = void 0;
const z = require("zod");
exports.DEFAULT_PAGE_SIZE = 20000;
exports.fromToPaginationSchema = z.object({
    from: z.coerce.number().optional(),
    to: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional().default(exports.DEFAULT_PAGE_SIZE),
});
